import React from 'react'
import FancySlider from '../elements/FancySlider'
import FormHOC from './FormHOC'
import Detail from '../elements/Detail'
import Button from '../elements/Button'
import store from '../store'

const options = {
    postUrl: '/api/postBuyUsageData',
    success: 'Success! Your data block has been added to your account.'
}

const state = {
    quantity: 0,
    quantityPeak: 0,
    quantityOffpeak: 0
}

class BuyUsageDataForm extends React.Component {
    constructor (props) {
        super(props)

        this.state = { hasNoData: false }
    }

    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    handleNoDataClick (e) {
        e.preventDefault()
        this.setState({ hasNoData: true })
    }

    setValue (name, value) {
        this.setState({ hasNoData: false })
        this.props.setDynamicValues({ [name]: parseInt(value) })
    }

    render () {
	    const Anytime = (
            <React.Fragment>
        <p className='font-medium'>Slide to select the number of data blocks you wish to buy</p>
        <FancySlider
                    name='quantity'
                    min='0'
                    max='5'
                    step='1'
                    value={this.props.values.quantity}
                    setValue={value => this.setValue('quantity', value)}
                    display={this.props.display}
                />
    </React.Fragment>
        )

	    const PeakOffpeak = (
            <React.Fragment>
        <div>
                    <p className='font-medium'>Slide to select the number of data blocks you wish to buy</p>
                    <FancySlider
                name='quantityPeak'
                min='0'
                max='5'
                step='1'
                value={this.props.values.quantityPeak}
                setValue={value => this.setValue('quantityPeak', value)}
                display={amount => `${amount * 10}GB <span class="color-indigo">Peak</span>`}
            />
                </div>
        <div>
                    <p className='font-medium'>Slide to select the number of data blocks you wish to buy</p>
                    <FancySlider
                name='quantityOffpeak'
                min='0'
                max='5'
                step='1'
                value={this.props.values.quantityOffpeak}
                setValue={value => this.setValue('quantityOffpeak', value)}
                display={amount => `${amount * 10}GB <span class="color-indigo">Off Peak</span>`}
            />
                </div>
    </React.Fragment>
        )

	    const calcTotal = () => {
            if (this.props.isAnytimeUsage) {
                return this.props.values.quantity * this.props.costPerGb
            } else {
                return (parseInt(this.props.values.quantityPeak) + parseInt(this.props.values.quantityOffpeak)) * this.props.costPerGb
            }
        }

	    const hasQuantity = this.props.values.quantity > 0 || this.props.values.quantityPeak > 0 || this.props.values.quantityOffpeak > 0

        return (
            <div>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2'>
                        <p>Anytime you need extra data, you can buy it here. Top up before you run out and we’ll add the extra data to your monthly allowance. If you’ve already blown through this month’s data, we can get you back in the game instantly if you pay by credit card below.</p>
                        <h1>10GB Data Block | ${this.props.costPerGb}</h1>
                        {this.props.isAnytimeUsage ? Anytime : PeakOffpeak}
                    </div>
                </div>
                <div className='row py-3 font-medium'>
                    <div className='col-6 col-md-4'>
                        <Detail title='Total cost' value={`$${calcTotal()}`} />
                    </div>
                    <div className='col-6 col-md-4'>
                        <Detail title='Additional data expires' value={this.props.expires} />
                    </div>
                    <div className='col-12 col-md-4 mt-3 mt-md-0'>
                        <Detail title='Billed to' value={store.getState().auth.paymentVia} />
                    </div>
                </div>

                {this.props.children}

                {this.state.hasNoData
                    ? <div className='row-error'>
                        You must select how many data blocks you require above
                      </div>
                    : ''}

                <div className='row py-3'>
                    <div className='col-12'>
                        <Button title='Buy Data Block' action={hasQuantity ? this.props.handleSubmit : this.handleNoDataClick.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

export default FormHOC(BuyUsageDataForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/BuyUsageDataForm.js